// extracted by mini-css-extract-plugin
module.exports = {"btn":"EnableMerchant_btn__3CN8c"};